import BillingsPlanEntryTaxiDriverAddResponse from "../../../../../api/raily/billings/plan-entry/taxi-driver/add/billings-plan-entry-taxi-driver-add.response";
import BillingsPlanEntryTaxiDriverAdd from "./billings-plan-entry-taxi-driver-add";

const create = (
  response: BillingsPlanEntryTaxiDriverAddResponse,
): BillingsPlanEntryTaxiDriverAdd => {
  return {
    id: response.data.id,
  };
};

const billingsPlanEntryTaxiDriverAddFactory = {
  create,
};

export default billingsPlanEntryTaxiDriverAddFactory;
